export enum CustomerHasOwnerEnum {
  all = 0,
  hasNotOwner = 1,
  hasOwner = 2,
}
export enum WorkOrderChangeStatusEnum {
  NotApproved = 1, // Onaylanmadı
  Approved = 2,
  Denied = 3,
}

export const TurkeyNationalityId = "187cf1ae-023f-ed11-a5f4-005056a2cd35";

export enum SignitureTypeEnum {
  ElectronicIdentity = 1,
  ESignature = 2,
}

export const customerOwnerGrupEnum = {
  e_donusum: "39eb94dc-2ed9-43c1-b523-19b1ceffe75b",
  kurumsal_satis: "22849c77-7513-42b1-99da-36d4c9208c79",
  idari_isler: "342cb3aa-93a4-4c2b-b9f8-39977e60ad06",
  satis_oncesi_muhendislik: "ecf11e0a-7a9c-4dfd-8ef6-bdc293fdc884",
  yazilimGelistirme: "41C985D9-4500-44C4-A23D-691A22D51F44",
  yonetim: "10f65ad6-e076-436d-8a64-1492bb3fe2fc",
  satis_direktorlugu: "1133a00c-1e3f-4be3-a6c5-ae878fd3ae33",
};

export enum AdSourceGroupEnum {
  OnlineChannel = 1,
  BusinessPartner = 2,
}

export enum PasswordFrequencyEnum {
  oneMonth = 1,
  threeMonths = 3,
  sixMonths = 6,
}

export enum productCategoryEnum {
  voiceService = 7,
  connectService = 5,
}

export enum paymentTypeEnum {
  new = 1,
  churn = 2,
}

export enum serviceTypeEnum {
  pstn = 1,
  pri = 2,
  bri = 3,
}

export enum serviceConnectTypeEnum {
  xdsl = 1,
}

export enum newTypeEnum {
  lean_internet = 1,
  lean_internet_fiber = 2,
  internet = 3,
  inter_fttx = 4,
}

export enum lineEnum {
  fixed_line = 1,
  lean_line = 2,
}

export enum paymentVoiceTypeEnum {
  thk = 66,
  voip = 67,
  sanal_santral = 77,
}

export const termsOfPaymentInvoiceGroupEnum = {
  TenDayTerm: 1, // 10 gün vadeli
  FifteenDayTerm: 2, // 15 gün vadeli
  TwentyDayTerm: 3, // 20 gün vadeli
  ThirtyDayTerm: 4, // 30 gün vadeli
  FortyFiveDayTerm: 5, // 45 gün vadeli
  SixtyDayTerm: 6, // 60 gün vadeli
  NinetyDayTerm: 7, // 90 gün vadeli
  CashPayment: 8, // Peşin Ödeme
  ExchangeRateDifference: 9, // Kur Farkı -- Merlin
};

export const invoicePeriodEnum = {
  forOnce: 1,
  monthly: 2,
  three_months: 3,
  twelve_months: 4,
  twenty_four_months: 5,
  thirty_six_months: 6,
  forty_eight_months: 7,
  sixty_months: 8,
};

export enum ExchangeRateUnitEnum {
  ActiveRate = 1,
  FixedRate = 2,
}

export const currencyEnum = {
  TRY: 1,
  USD: 2,
  EUR: 3,
  GBP: 4,
};

export enum DDTechTypeEnum {
  Template = 1,
  Document = 2,
}

export enum InfrastructureEnum {
  Pstn = 1,
  Xdsl = 2,
}

export enum MerlinProductGroupDetail {
  THK = 66,
  VOIP = 67,
}
